/**
 * Desktop - Reward notifications organism.
 */

// Imports
import {
  registerCallback as registerEventCallback,
} from '../../common/Events';
import {
  closeCart,
} from '../molecule/cart-items';

import { addToDataLayer } from '../../common/DataLayer';

/* global OCMS */

// Constants (ids)
const rewardQuickLinkId = 'rewardQuickLink';
const rewardNotificationsAreaId = 'rewardNotificationsArea';

/**
 * Reference to the cart "quick link" element.
 * @type {Object}
 */
let $rewardQuickLink = {};

/**
 * Reference to the reward notifications area element.
 * @type {Object}
 */
let $rewardNotificationsArea = {};

/**
 * Indicator for whether or not the reward notifications area is visible.
 * @type {Boolean}
 */
let rewardNotificationsAreaVisible = false;

/**
 * Reference to the close animation timeout.
 * @type {Object}
 */
let closingTimeout = null;

/**
 * Indicator for whether or not a fade animation is occurring.
 * @type {Boolean}
 */
let fadeAnimationOccurring = false;

function saveReferences() {
  // Save reference to the reward "quick link" element
  $rewardQuickLink = $(`#${rewardQuickLinkId}`);

  // Save reference to the reward notifications area element
  $rewardNotificationsArea = $(`#${rewardNotificationsAreaId}`);
}

function openNotifications() {
  if (!fadeAnimationOccurring && !rewardNotificationsAreaVisible) {
    fadeAnimationOccurring = true;

    // Show the reward notifications
    $rewardNotificationsArea.fadeIn({
      duration: 'fast',
      complete: () => {
        fadeAnimationOccurring = false;

        rewardNotificationsAreaVisible = true;
      },
    });
  }
}

function animateClosing() {
  fadeAnimationOccurring = true;

  $rewardNotificationsArea.fadeOut({
    duration: 'fast',
    complete: () => {
      fadeAnimationOccurring = false;

      rewardNotificationsAreaVisible = false;
    },
  });
}

function closeNotifications(anDelay) {
  /* if (typeof OCMS !== 'undefined' && OCMS.isCheckout && OCMS.isCheckout()) {
    return;
  } */

  if (!fadeAnimationOccurring && rewardNotificationsAreaVisible) {
    // Hide the reward notifications
    if (anDelay >= 0) {
      closingTimeout = setTimeout(animateClosing, anDelay);
    } else {
      animateClosing();
    }
  }
}

function rewardHoverCtaMenu() {
  let timer;
  $('.o-reward-notifications__btn').mouseover(() => {
    timer = setTimeout(() => {
      addToDataLayer({
        event: 'rewardHoverCtaMenu',
      });
    }, 1000);
  }).mouseout(() => {
    clearTimeout(timer);
  });
}


function setEventHandlers() {
  if ($rewardQuickLink.length) {
    registerEventCallback({
      target: $rewardQuickLink,
      events: 'mouseover focusin',
      handler: function onRewardQuickLinkMouseover() {
        clearTimeout(closingTimeout);

        // Show the notifications items
        closeCart();
        openNotifications();
      },
    });

    registerEventCallback({
      target: $rewardQuickLink,
      events: 'mouseout focusout',
      handler: function onRewardQuickLinkMouseout(aoEvent) {
        clearTimeout(closingTimeout);

        // Hide the reward notifications
        closeNotifications((aoEvent.type === 'focusout') ? 100 : 1000);
      },
    });
  }

  if ($rewardNotificationsArea.length) {
    registerEventCallback({
      target: $rewardNotificationsArea,
      events: 'mouseover focusin',
      handler: function onRewardNotificationsAreaMouseover() {
        clearTimeout(closingTimeout);
      },
    });

    registerEventCallback({
      target: $rewardNotificationsArea,
      events: 'mousemove',
      handler: function onRewardNotificationsAreaMousemove() {
        clearTimeout(closingTimeout);
      },
    });

    registerEventCallback({
      target: $rewardNotificationsArea,
      events: 'mouseout focusout',
      handler: function onRewardNotificationsAreaMouseout() {
        // Hide the reward notifications
        closeNotifications(400);
      },
    });
  }
}


function init() {
  // Save references to DOM elements
  saveReferences();

  // data rewardCTAMenu
  rewardHoverCtaMenu();

  // Set event handlers
  setEventHandlers();

  // Prevent closing
  clearTimeout(closingTimeout);
}

// Named exports - Functions
export {
  init,
  openNotifications,
  closeNotifications,
};



// WEBPACK FOOTER //
// ./js/desktop/organism/reward-notifications.js